import React from "react";
import { API, downloadWithToast } from "@/lib/apiClient";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { DownloadSimple } from "@phosphor-icons/react";

export default function SlipPreviewDialog({ runId, idx, row, filename, onClose }) {
  const src = `${API}/payroll/runs/${runId}/slips/${idx}/pdf?inline=true#toolbar=0&navpanes=0&view=FitH`;
  return (
    <Dialog open onOpenChange={(v) => !v && onClose?.()}>
      <DialogContent className="max-w-[900px] w-[95vw] p-0 overflow-hidden" data-testid="slip-preview-dialog">
        <DialogHeader className="px-4 pt-3 pb-2 border-b border-slate-200">
          <DialogTitle className="flex items-center justify-between gap-3 text-sm">
            <span>Salary Slip · <span className="font-display">{row?.name}</span></span>
            <Button size="sm" variant="outline" className="h-7 text-[11px] mr-6" onClick={() => downloadWithToast(`/payroll/runs/${runId}/slips/${idx}/pdf`, filename).catch(() => {})} data-testid="slip-preview-download">
              <DownloadSimple size={12} className="mr-1" /> Download PDF
            </Button>
          </DialogTitle>
        </DialogHeader>
        <iframe title="Salary slip preview" src={src} className="w-full h-[78vh] bg-slate-100" data-testid="slip-preview-iframe" />
      </DialogContent>
    </Dialog>
  );
}
